import React from 'react';
import { Fade } from "react-awesome-reveal";
import hImg from '../../images/shape/hero-glassisom2.png';

const Hero3 = () => {



    return (
        <section className="hero hero-style-six pos-rel pt-110">
            <div className="container">
                <div className="hero_wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="xb-hero">
                                
                                {/* Heading */}
                                <Fade direction="up" triggerOnce={false} duration={800} delay={6}>
                                    <div>
                                        <h1
                                            className="xb-item--title wow fadeInUp"
                                            data-wow-delay="0ms"
                                            data-wow-duration="600ms"
                                        >
                                            B2B Conferences & Events<br />
                                            That Drive Innovation.
                                        </h1>
                                    </div>
                                </Fade>

                                {/* Description */}
                                <Fade direction="up" triggerOnce={false} duration={1500} delay={9}>
                                    <div>
                                        <p
                                            className="xb-item--content wow fadeInUp"
                                            data-wow-delay="150ms"
                                            data-wow-duration="600ms"
                                        >
                                            ARO Events connects industry leaders, corporations, government agencies,
                                            and investors through high-impact conferences designed to foster
                                            collaboration, spark innovation, and unlock strategic growth.
                                        </p>
                                    </div>
                                </Fade>

                                {/* CTA */}
                             

                            </div>
                        </div>
                    </div>
                </div>

                {/* Decorative Shape */}
                <div className="xb-shape">
                    <img src={hImg} alt="" />
                </div>
            </div>
        </section>
    );
};

export default Hero3;
